"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[746],{

/***/ 4746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9630);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1953);
/* harmony import */ var _mui_material_Paper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(1401);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9144);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(9072);
/* harmony import */ var _context_DialogContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3823);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Slide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5425);
/* harmony import */ var _mui_system_useTheme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2843);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1890);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7745);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(562);
/* harmony import */ var _mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4642);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5398);
/* harmony import */ var _mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9063);
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5343);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(9041);
/* harmony import */ var _mui_icons_material_Public__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(9055);
/* harmony import */ var _mui_icons_material_PhoneAndroid__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(4247);























var Transition = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Slide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        direction: "up",
        ref: ref
    }, props));
});
var buttonGradientStyle = {
    background: "linear-gradient(to right, #e61e4d, #d80665)"
};
var ModalDialog = function() {
    // @ts-ignore
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_DialogContext__WEBPACK_IMPORTED_MODULE_2__/* .DialogContext */ .MJ), open = ref.open, setOpen = ref.setOpen;
    // const [open, setOpen] = React.useState(false);
    var handleOpen = function() {
        return setOpen(true);
    };
    var handleClose = function() {
        return setOpen(false);
    };
    var theme = (0,_mui_system_useTheme__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)();
    // @ts-ignore
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            PaperProps: {
                style: {
                    borderRadius: 18,
                    padding: "0.5rem 0"
                }
            },
            open: open,
            onClose: function() {
                return setOpen(false);
            },
            "aria-labelledby": "dialog-title",
            "aria-describedby": "dialog-description",
            // @tes-ignore
            TransitionComponent: Transition,
            keepMounted: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    id: "dialog-title",
                    my: 1,
                    sx: {
                        borderBottom: "1px solid #ddd"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                sx: {
                                    p: 0
                                },
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    src: "/icons/MdOutlineCancel.svg",
                                    width: "24",
                                    height: "24",
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                fontWeight: "bold",
                                fontSize: "large",
                                children: "Login or sign up"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                align: "left",
                                my: 2,
                                fontSize: "large",
                                fontWeight: "bold",
                                color: "black",
                                children: "Welcome"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                component: "form",
                                noValidate: true,
                                autoComplete: "off",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        sx: {
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                position: "end",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Public__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    fontSize: "small",
                                                    sx: {
                                                        marginRight: 1
                                                    }
                                                })
                                            }),
                                            sx: {
                                                borderRadius: "8px 8px 0 0"
                                            },
                                            placeholder: "Country/Region"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        sx: {
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                                            sx: {
                                                width: "100%"
                                            },
                                            startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                position: "end",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_PhoneAndroid__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    fontSize: "small",
                                                    sx: {
                                                        marginRight: 1
                                                    }
                                                })
                                            }),
                                            placeholder: "Phone number"
                                        }, "sx", {
                                            borderRadius: "0 0 8px 8px"
                                        }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                sx: {
                                    fontSize: "0.7rem"
                                },
                                variant: "subtitle2",
                                my: 2,
                                children: "We’ll call or text you to confirm your number. Standard message and data rates apply. Privacy Policy"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    color: "white",
                                    height: 50,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: 3,
                                    cursor: "pointer",
                                    backgroundColor: buttonGradientStyle,
                                    "&:hover": {
                                        backgroundColor: theme.palette.secondary.main,
                                        opacity: [
                                            0.9,
                                            0.9,
                                            0.9
                                        ]
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    fontSize: 16,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        children: "Continue"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                my: 2,
                                align: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    children: "Or"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                                sx: {
                                    cursor: "pointer"
                                },
                                container: true,
                                direction: "column",
                                gap: 1,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Paper__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        variant: "outlined",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    sx: {
                                                        p: 0
                                                    },
                                                    onClick: handleClose,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "/icons/icons8-facebook-48.png",
                                                        width: "24",
                                                        height: "24",
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    align: "center",
                                                    variant: "body2",
                                                    fontWeight: "bold",
                                                    children: "Continue with facebook"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Paper__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        variant: "outlined",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    sx: {
                                                        p: 0
                                                    },
                                                    onClick: handleClose,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "/icons/FcGoogle.svg",
                                                        width: "24",
                                                        height: "24",
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    align: "center",
                                                    variant: "body2",
                                                    fontWeight: "bold",
                                                    children: "Continue with Google"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Paper__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        variant: "outlined",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    sx: {
                                                        p: 0
                                                    },
                                                    onClick: handleClose,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "/icons/AiFillApple.svg",
                                                        width: "24",
                                                        height: "24",
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    align: "center",
                                                    variant: "body2",
                                                    fontWeight: "bold",
                                                    children: "Continue with Apple"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Paper__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                        variant: "outlined",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    sx: {
                                                        p: 0
                                                    },
                                                    onClick: handleClose,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "/icons/AiOutlineMail.svg",
                                                        width: "24",
                                                        height: "24",
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    align: "center",
                                                    variant: "body2",
                                                    fontWeight: "bold",
                                                    children: "Continue with E-mail"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ModalDialog);


/***/ })

}]);